import React from 'react';
import {Category} from '../../App';

const Icon = ({
  type,
  ...props
}: { type: Category } & React.SVGProps<SVGSVGElement>) => {
  switch (type) {
    case Category.Battery_Manufacturers:
      return (
        <svg
          {...props}
          id="icon_battery_manufacturers"
          xmlns="http://www.w3.org/2000/svg"
          version="1.1"
          viewBox="0 0 124 124"
        >
          <path d="M105.3,35.9h-7.5v-1.7c0-.6-.5-1.2-1.2-1.2h-8.7c-.6,0-1.2.5-1.2,1.2v1.7h-49.7v-1.7c0-.6-.5-1.2-1.2-1.2h-8.7c-.6,0-1.2.5-1.2,1.2v1.7h-7.5c-.6,0-1.2.5-1.2,1.2v5.8c0,.6.5,1.2,1.2,1.2h1.7v47.9c0,.6.5,1.2,1.2,1.2h80.8c.6,0,1.2-.5,1.2-1.2v-47.9h1.7c.6,0,1.2-.5,1.2-1.2v-5.8c0-.6-.5-1.2-1.2-1.2ZM73,63.7l-14.4,20.2c-.2.3-.6.5-.9.5s-.4,0-.6-.1c-.5-.3-.7-.9-.5-1.4l5.1-12.9h-9.8c-.4,0-.8-.2-1-.5-.2-.3-.2-.8,0-1.1l8.7-17.3c.2-.4.6-.6,1-.6h8.7c.4,0,.8.2,1,.5.2.3.2.8,0,1.1l-4.9,9.9h6.8c.4,0,.8.2,1,.6s.2.8,0,1.2Z" />
        </svg>
      );
    case Category.Battery_Recycling:
      return (
        <svg
          {...props}
          id="icon_battery_recycling"
          xmlns="http://www.w3.org/2000/svg"
          version="1.1"
          viewBox="0 0 124 124"
        >
          <path d="M92.3,19.2l-26.7,4.7,13,23.8,3.7-7.6c6.6,5.2,11,13.3,11,22.5s-.8,7.4-2.1,10.8l13.9.4c1-3.6,1.5-7.2,1.5-11.1,0-14.5-7.3-27.2-18.5-34.9l4.1-8.7ZM53.7,22c-17.1,4.5-30,19.5-31.3,37.7l-9.6.8,17.5,20.7,14.1-23.2-8.4.7c1.9-12.6,11.8-22.5,24.4-24.3l-6.7-12.4ZM41.9,80.4l-7.4,12c7.6,7.7,18.3,12.4,29.9,12.4s12.8-1.6,18.4-4.2l5.4,7.9,9.2-25.6-27.1-.6,4.7,6.9c-3.3,1.3-6.8,2-10.6,2-9.1.1-17.3-4.1-22.5-10.9h0Z" />
        </svg>
      );
    case Category.Battery_Parts_Suppliers:
      return (
        <svg
          {...props}
          id="icon_battery_parts"
          xmlns="http://www.w3.org/2000/svg"
          version="1.1"
          viewBox="0 0 115 115"
        >
          <path d="M93.9,38.8h-59.9c-2.1,0-3.8,1.7-3.8,3.8v4.1h-4.1c-2.1,0-3.8,1.7-3.8,3.8v21.1c0,2.1,1.7,3.8,3.8,3.8h4.1v4.1c0,2.1,1.7,3.8,3.8,3.8h59.9c2.1,0,3.8-1.7,3.8-3.8v-36.9c0-2.1-1.7-3.8-3.8-3.8ZM45.7,75.7h-6.8c-.6,0-1.1-.5-1.1-1.1v-27.1c0-.6.5-1.1,1.1-1.1h6.8c.6,0,1.1.5,1.1,1.1v27.1c0,.6-.5,1.1-1.1,1.1ZM60.1,75.7h-6.8c-.6,0-1.1-.5-1.1-1.1v-27.1c0-.6.5-1.1,1.1-1.1h6.8c.6,0,1.1.5,1.1,1.1v27.1c0,.6-.5,1.1-1.1,1.1ZM74.6,75.7h-6.8c-.6,0-1.1-.5-1.1-1.1v-27.1c0-.6.5-1.1,1.1-1.1h6.8c.6,0,1.1.5,1.1,1.1v27.1c0,.6-.5,1.1-1.1,1.1ZM89,75.7h-6.8c-.6,0-1.1-.5-1.1-1.1v-27.1c0-.6.5-1.1,1.1-1.1h6.8c.6,0,1.1.5,1.1,1.1v27.1c0,.6-.5,1.1-1.1,1.1Z" />
        </svg>
      );
    case Category.Battery_Assembly:
      return (
        <svg {...props} id="icon_battery_parts" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 124 124">
          <path d="M106.4,63.8l-7-15.3c-.3-.7-.9-1.3-1.7-1.6l-14.9-5.9c-.8-.3-1.6-.3-2.4,0-.8.3-1.4,1-1.7,1.7-.3.8-.3,1.7,0,2.4.3.8,1,1.4,1.7,1.7l7.5,3-26,10.4-26-10.4,7.5-3c1.6-.7,2.4-2.5,1.8-4.1-.3-.8-.9-1.4-1.7-1.7-.8-.3-1.6-.3-2.4,0l-14.9,5.9c-.8.3-1.4.9-1.7,1.6l-6.9,15.2c-.7,1.6,0,3.5,1.6,4.2l5.1,2.1v21.3c0,1.3.8,2.5,2,2.9l34.6,13.8c.4.2.8.2,1.2.2s.7,0,1.1-.2l34.6-12.4c1.3-.5,2.1-1.7,2.1-3v-22.7l5-2.1c1.6-.7,2.4-2.5,1.7-4.2ZM99.2,63.4l-27.5,11.5-5.2-9.6,28.4-11.4,4.3,9.5ZM57.5,65.3l-5.2,9.6-27.5-11.5,4.3-9.5,28.4,11.4ZM30.6,72.7l21.9,9.1c1.5.6,3.2,0,4-1.4l2.3-4.3v24.3l-28.2-11.3v-16.5Z"/>
          <path d="M76.9,29.3c-1.3-1.3-3.4-1.3-4.6,0l-7,7v-17.3c0-1.8-1.5-3.3-3.3-3.3s-3.3,1.5-3.3,3.3v17.3l-7-7c-1.3-1.3-3.4-1.3-4.6,0-1.3,1.3-1.3,3.4,0,4.6l12.5,12.5c.4.4.8.6,1.4.8.3.1.7.2,1,.2s.7,0,1-.2c.5-.2,1-.4,1.4-.8l12.5-12.5c1.3-1.3,1.3-3.4,0-4.6Z"/>
        </svg>
      );
    case Category.EV_Parts_Supplies:
      return (
        <svg {...props} id="icon_ev_parts" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 124 124">
          <path d="M89.1,70.3h-12.5v8.3h12.5v-8.3M101.6,99.5H22.4v-41.7L55.7,24.5h41.7c1.1,0,2.2.4,2.9,1.2s1.2,1.8,1.2,2.9v70.8M59.2,32.8l-25,25h59v-25h-34Z"/>
        </svg>
      );
    case Category.EV_Manufacturing:
      return (
        <svg
          {...props}
          id="icon_ev"
          xmlns="http://www.w3.org/2000/svg"
          version="1.1"
          viewBox="0 0 124 124"
        >
          <path d="M112.7,44.8h-4c-1.9,0-3.7.8-5.1,2.1l-1.6,1.7-8.4-13.7c-1.6-2.5-3.8-4.4-6.4-5.6-6.4-3.3-22.8-2.9-24.6-2.9h-1c-1.8,0-18.2-.5-24.6,2.9-2.6,1.2-4.9,3.2-6.5,5.6l-8.3,13.6-1.6-1.7c-1.4-1.3-3.2-2.1-5.1-2.1h-4c-1.7,0-3,1.4-3,3.2s1.4,3.2,3,3.2h6.1c.7,0,1.3.3,1.9.7-4.1,2.6-6.7,7.2-6.9,12.2v29c0,1.1.4,2.2,1.2,3s1.8,1.3,2.9,1.3h10.1c2.2,0,4-1.9,4-4.3v-4.3h62.7v4.3c0,1.1.4,2.2,1.2,3,.8.8,1.8,1.3,2.9,1.3h10.1c1.1,0,2.1-.5,2.9-1.3s1.2-1.9,1.2-3v-29c-.3-5-2.9-9.6-6.9-12.2.5-.4,1.2-.7,1.9-.7h6.1c1.7,0,3-1.4,3-3.2s-1.4-3.2-3-3.2ZM26.5,49.7l7.4-12.2c1.1-1.8,2.7-3.2,4.6-4h.3c4.6-2.6,18-2.7,22.9-2.6h1.1c4.8-.1,18.2,0,22.8,2.5h.2c1.8,1,3.4,2.3,4.5,4.1l7.5,12.3c.2.3.2.7,0,1.1-.2.3-.5.5-.9.5H27.3c-.4,0-.7-.2-.9-.5-.2-.3-.2-.7,0-1.1ZM30.2,72.7h0c-2.3,1.7-5.4,1.5-7.5-.5-2.1-2-2.7-5.2-1.4-7.8s4.1-4,6.8-3.3c2.7.7,4.6,3.3,4.6,6.3,0,2.1-1,4.1-2.6,5.3ZM70.4,69.5l-8.5,10.9-2.2,2.8-.3.3h0c0,0,0,.1-.1.1,0,0,0,0,0,0,0,0,0,0-.1,0h0s0,0-.1,0h0s0,0-.1,0h0c0,0-.1,0-.2,0h0c0,0-.1,0-.2,0h0c0,0,0,0-.1-.1h0c0,0,0-.1-.1-.2h0c0,0,0-.1,0-.2,0,0,0,0,0,0s0,0,0,0h0c0,0,0-.1,0-.2h0v-.2h0c0-.2,0-.2,0-.3l.8-2.1,3.1-8h-7c-.3,0-.7-.2-.9-.4-.2-.3-.3-.6-.3-1,0-.3.1-.5.3-.7h0l8.5-10.9,2.2-2.8.3-.3h0c0,0,0-.1.1-.1h0s0,0,0,0c0,0,0,0,.1,0h0s0,0,0,0h0s0,0,0,0c0,0,0,0,.1,0h0c0,0,.1,0,.2,0,0,0,.1,0,.2,0h0c0,0,0,0,.1.1h0c0,0,0,.1.1.2h0c0,0,0,.1,0,.2,0,0,0,0,0,0s0,0,0,0c0,0,0,.1,0,.2h0v.2h0c0,.2,0,.2,0,.3l-.8,2.1-3.1,8h7c.5,0,.9.3,1.1.8.2.5.1,1-.2,1.4ZM102.7,70.6h0c-1.5,2.8-4.8,4-7.6,2.7-2.8-1.2-4.3-4.5-3.5-7.6.8-3.1,3.6-5.1,6.7-4.7,3,.4,5.3,3.2,5.3,6.4s-.3,2.2-.8,3.2Z" />
        </svg>
      );
  }

  return null;
};

export default Icon;
